// @module BTM.BrowserCompatibility.BrowserCompatibility
define('BTM.BrowserCompatibility.BrowserCompatibility.View'
    , [
        'btm_browsercompatibility_browsercompatibility.tpl'

        , 'BTM.BrowserCompatibility.BrowserCompatibility.SS2Model'

        , 'Backbone'
        , 'GlobalViews.Confirmation.View'
        , 'Utils'
        , 'jQuery'
    ]
    , function (
        btm_browsercompatibility_browsercompatibility_tpl
        , BrowserCompatibilitySS2Model
        , Backbone
        , GlobalViewsConfirmationView
        , Utils
        , jQuery
    ) {
        'use strict';

        // @class BTM.BrowserCompatibility.BrowserCompatibility.View @extends Backbone.View
        return Backbone.View.extend({

            template: btm_browsercompatibility_browsercompatibility_tpl

            , initialize: function (options) {
                this.application = options.container;
                this.browsers = options.browsers || {};
                this._browser = {};
                this.thisBrowser = '';
                this.configs = options.configs || {};
                this.on('afterViewRender', this.checkBrowserVersion);
            }

            , checkBrowserVersion: function () {
                var uagent = navigator.userAgent.toLowerCase(), match = '';

                this._browser.edg = /edg/.test(uagent) || /trident/.test(uagent);

                this._browser.safari = /safari/.test(uagent) && /applewebkit/.test(uagent) && !/chrome/.test(uagent);

                this._browser.opr = /mozilla/.test(uagent) && /applewebkit/.test(uagent) && /chrome/.test(uagent) && /safari/.test(uagent) && /opr/.test(uagent);

                this._browser.chrome = /webkit/.test(uagent) && /chrome/.test(uagent) && !/edge/.test(uagent);

                this._browser.firefox = /mozilla/.test(uagent) && /firefox/.test(uagent);

                this._browser.msie = /msie/.test(uagent) || /trident/.test(uagent);

                this._browser.version = '';

                for (var x in this._browser) {
                    if (this._browser[x]) {
                        this.thisBrowser = x;
                        match = uagent.match(
                            new RegExp("(" + x + ")( |\/)([0-9]+)")
                        );

                        if (match) {
                            this._browser.version = match[3];
                        } else {
                            match = uagent.match(new RegExp("rv:([0-9]+)"));
                            this._browser.version = match ? match[1] : "";
                        }
                        break;
                    }
                }
                if (!isNaN(this._browser.version)) {
                    this._browser.version = parseInt(this._browser.version, 10);
                }
                //this._browser.opera = this._browser.opr;
                //delete this._browser.opr;
                if (!this.thisBrowser || isNaN(this._browser.version)) {
                    this.showUnknownBrowserAlert();
                } else if (this._browser.version < this.browsers[this.thisBrowser].version) {
                    this.showUnsupportedBrowserAlert();
                }
            }

            , showUnsupportedBrowserAlert: function () {
                var options = {name: this.browsers[this.thisBrowser].name, version: this._browser.version};
                var self = this;
                if (this.configs.unknownBrowserMessage) {
                    let alert = new GlobalViewsConfirmationView({
                        title: 'Browser Compatibility',
                        body: Utils.translate(this.configs.unsupportedBrowserMessage, options.name, options.version),
                        callBack: function (options) {
                            if (self.configs.supportedBrowserPage) {
                                Backbone.history.navigate(self.configs.supportedBrowserPage, {
                                    trigger: true,
                                    replace: true
                                });
                            }
                        }
                    });
                    this.application.getLayout().showInModal(alert);
                    setTimeout(function () {
                        jQuery('.global-views-confirmation-confirm-button').text("Ok");
                        jQuery('.global-views-confirmation-cancel-button').css('display', 'none');
                    }, 500);
                }
            }

            , showUnknownBrowserAlert: function () {
                var self = this;
                if (this.configs.unknownBrowserMessage) {
                    let alert = new GlobalViewsConfirmationView({
                        title: 'Browser Compatibility',
                        body: this.configs.unknownBrowserMessage,
                        callBack: function (options) {
                            if (self.configs.supportedBrowserPage) {
                                Backbone.history.navigate(self.configs.supportedBrowserPage, {
                                    trigger: true,
                                    replace: true
                                });
                            }
                        }
                    });
                    this.application.getLayout().showInModal(alert);
                    setTimeout(function () {
                        jQuery('.global-views-confirmation-confirm-button').text("Ok");
                        jQuery('.global-views-confirmation-cancel-button').css('display', 'none');
                    }, 500);
                }
            }

            , events: {}

            , bindings: {}

            , childViews: {}

            //@method getContext @return BTM.BrowserCompatibility.BrowserCompatibility.View.Context
            , getContext: function getContext() {
                //@class BTM.BrowserCompatibility.BrowserCompatibility.View.Context
                return {};
            }
        });
    });
